import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TenantConfirmDialogData {
  /** Title shown at the top of the dialog. */
  title: string;
  /** Message body — supports a single line or paragraph. */
  message: string;
  /** Optional secondary line (e.g. "This operation is irreversible..."). */
  detail?: string;
  /** Label for the confirm button. */
  confirmLabel: string;
  /** Label for the cancel button. */
  cancelLabel: string;
  /** When {@code true}, paints the confirm button as a destructive action. */
  dangerous?: boolean;
}

/**
 * Generic confirmation dialog used for the tenant actions defined in the spec
 * (delete / activate / deactivate). Returns {@code true} on confirm and
 * {@code false}/{@code undefined} on cancel.
 */
@Component({
  standalone: false,
  selector: 'app-tenant-confirm-dialog',
  templateUrl: './tenant-confirm-dialog.component.html',
  styleUrls: ['./tenant-confirm-dialog.component.css']
})
export class TenantConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TenantConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: TenantConfirmDialogData
  ) { }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
